import React from "react";
import {Header} from "semantic-ui-react";

const rating = [
    {key: 0, text: '0', value: 0, content:(<Header className='itemFont' subheader='0'/>)},
    {key: 1, text: '1', value: 1, content:(<Header className='itemFont' subheader='1'/>)},
    {key: 2, text: '2', value: 2, content:(<Header className='itemFont' subheader='2'/>)},
    {key: 3, text: '3', value: 3, content:(<Header className='itemFont' subheader='3'/>)},
    {key: 4, text: '4', value: 4, content:(<Header className='itemFont' subheader='4'/>)},
    {key: 5, text: '5', value: 5, content:(<Header className='itemFont' subheader='5'/>)},
]

export default rating
